import {
	Dialog,
	DialogTitle,
	DialogContent,
	dialogClasses
} from '@/components/Dialog';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { showError } from '@/utils';
import { Box, CircularProgress } from '@mui/material';
import { useMatch } from 'react-router-dom';
import routes from '@/routes';
import { getPaymentModule } from '@/components/payment/getPaymentModule';
import { PAYMENT_HANDLER } from '@/config';
import { fetchBillingInfo } from '@/store/auth/thunks';
import { usePaymentMethod, useShallowEqualSelector } from '@/hooks';

const { PaymentElement } = getPaymentModule(PAYMENT_HANDLER);

export function UpdatePaymentMethod({
	title,
	userPlan,
	paymentInfo,
	subscriptionInfo,
	...props
}) {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const isPaymentMethodRoute = !!useMatch(routes.paymentMethod);

	const { hasPaymentMethod } = usePaymentMethod();

	const { ready, currency, priceCurrency } = useShallowEqualSelector(
		state => ({
			ready: state.auth.billingInfoReady,
			currency: state.auth?.currency,
			priceCurrency: state.auth?.priceCurrency
		})
	);

	const update = hasPaymentMethod;

	const loadingRender = (
		<Box
			sx={{
				minHeight: 130,
				display: 'flex',
				justifyContent: 'center',
				pt: 3
			}}
		>
			<CircularProgress />
		</Box>
	);

	function handleClose() {
		window.location.href = routes.billing;
	}

	async function onSavedPaymentMethod() {
		await dispatch(fetchBillingInfo()).unwrap();

		return handleClose();
	}

	async function handleSetupErr() {
		showError(t('errors.generic'));

		return handleClose();
	}

	if (!isPaymentMethodRoute) {
		return null;
	}

	return (
		<Dialog
			open
			onClose={handleClose}
			sx={{
				[`.${dialogClasses.paper}`]: {
					width: '100%',
					pt: 3,
					pb: 2
				}
			}}
			maxWidth="xs"
			{...props}
		>
			<DialogTitle>
				{update
					? t('billing.updatePaymentMethod')
					: t('billing.addPaymentMethod')}
			</DialogTitle>
			<DialogContent>
				{!ready && loadingRender}
				{ready && (
					<PaymentElement
						mode="update"
						currency={currency || priceCurrency}
						onSuccess={onSavedPaymentMethod}
						onError={handleSetupErr}
					/>
				)}
			</DialogContent>
		</Dialog>
	);
}
